import { render, staticRenderFns } from "./FormTemplateCreate.vue?vue&type=template&id=68348fde&scoped=true"
import script from "./FormTemplateCreate.vue?vue&type=script&lang=js"
export * from "./FormTemplateCreate.vue?vue&type=script&lang=js"
import style1 from "./FormTemplateCreate.vue?vue&type=style&index=1&id=68348fde&prod&scoped=true&lang=css"
import style2 from "./FormTemplateCreate.vue?vue&type=style&index=2&id=68348fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68348fde",
  null
  
)

export default component.exports